<template>
  <v-container fill-height fluid>
    <v-row align="center"
           justify="center">
      <v-col cols="12" md="7">
        <v-card :loading="loading" :disabled="loading" v-model="item.info">
          <v-toolbar
              flat
              color="primary"
              dark
              class="justify-center">
            <v-toolbar-title>{{$t('profile.title')}}</v-toolbar-title>
          </v-toolbar>

          <!--    Name and gender      -->
          <v-list-item three-line>
            <v-list-item-content>

              <v-list-item-title class="mb-1 cTitle">
                {{$t('register.name_text_field')}} : {{ item.info.first_name + " " + item.info.last_name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ $t('profile.gender') + ' : ' +  item.info.gender}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar

                size="80"
                color="background"
            >
              <v-icon x-large color="primary">
                mdi-account
              </v-icon>
            </v-list-item-avatar>
          </v-list-item>
          <v-divider/>

          <!--    email input and country    -->
          <v-row class="pa-4">

            <v-col cols="12" sm="6">
              <div class="no-spacing">
                {{$t('login.email_input')}}:
                <span class="ltr">
                  {{ item.info.email }}
                </span>
              </div>
            </v-col>

            <v-divider></v-divider>
            <v-col cols="12" sm="6">
              <div class="no-spacing">
                {{$t('register.country')}}:
                <span>
                  {{ item.info.country }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <!--    phone and birthday      -->
          <v-row class="pa-4">
            <v-col cols="12" sm="6">
              <div class="no-spacing">
                {{$t('profile.phone_number')}}:
                <span>
                  {{ item.info.phone }}
                </span>
              </div>
            </v-col>


            <v-divider></v-divider>
            <v-col cols="12" sm="6">
              <div class="no-spacing">
                {{ $t('profile.birthday') }}:
                <span>{{ item.info.birthday }}</span>
              </div>
            </v-col>

          </v-row>
          <v-divider/>

        </v-card>
        <v-spacer></v-spacer>

        <!--    Submitted Movies    -->
        <v-card class="mt-4" :loading="loading" :disabled="loading">
          <v-toolbar
              flat
              color="primary"
              dark
              class="justify-center">
            <v-toolbar-title>{{$t('profile.sent_media')}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-for="(movie,index) in item.movies" :key='movie'>
            <v-row class="">
              <v-col cols="12">
                <v-card color="gray" light>
                  <v-card-title>
                    <v-icon large color="secondary" class="ma-1">
                      mdi-{{ get_category(movie.category).icon }}
                    </v-icon>
                    {{ movie.name }}
                    <br>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="change_open(index)"
                    >
                      <v-icon>{{ show_movie[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-subtitle>
                    {{$t('profile.category')}}: {{ get_category(movie.category).name }}

                    <br>
                    {{$t('profile.sent_date')}}: {{ movie.submitted_at }}
                  </v-card-subtitle>


                  <v-expand-transition>
                    <v-list v-show="show_movie[index]" dense>
                      <v-card-title>{{ $t('profile.information_media') }}</v-card-title>
                      <v-card-text>
                        <v-row class="pa-4">
                          <v-col cols="12" sm="6">
                            <div class="no-spacing">
                              {{$t('profile.media_title')}}:
                              <span class="ltr">
                              {{ movie.name }}
                            </span>
                            </div>
                          </v-col>
                          <v-divider></v-divider>
                          <v-col cols="12" sm="6">
                            <div class="no-spacing">
                              {{$t('profile.category')}}:
                              <span>
                              {{ get_category(movie.category).name }}
                            </span>
                            </div>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="pa-4">
                          <v-col cols="12" sm="6">
                            <div class="no-spacing">
                              {{$t('profile.details')}}:
                              <span>
                        {{ movie.description }}
                        </span>
                            </div>

                          </v-col>

                        </v-row>
                        <v-divider/>
                      </v-card-text>

                      <v-card-title>{{$t('profile.media_cast')}}</v-card-title>
                      <v-card-text>
                        <template
                            v-for="cast in movie.cast"

                        >
                          <v-row
                              class="ma-2"
                              :key="cast">
                            <v-col> {{$t('profile.cast_name')}}: {{ cast.first_name + " " + cast.last_name }}</v-col>
                            <v-col> {{ $t('profile.cast_rule') }}: {{ cast.type }}</v-col>
                            <v-col> {{ $t('login.email_input') }}: {{ cast.email }}</v-col>
                          </v-row>
                          <v-divider
                              :key="cast"/>
                        </template>


                      </v-card-text>

                      <!--         Attachments             -->
                      <div v-if="movie.attachment.length>0">
                        <v-card-title>{{ $t('profile.extra_files') }}</v-card-title>
                        <v-card-subtitle>
                          {{$t('profile.extra_files_detail')}}
                        </v-card-subtitle>
                        <v-card-text>

                          <template v-for="(extra,index) in movie.attachment">
                            <v-chip link color="secondary" :key="index" :href="extra.document_file" target="_blank">
                              {{ extra.type_text }}
                            </v-chip>
                          </template>
                        </v-card-text>
                        <v-divider/>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col align="center">
                            <v-btn
                                color="secondary"
                                link
                                :href="movie.document_file"
                                target="_blank"
                            >
                              {{$t('profile.download_extra')}}
                            </v-btn>
                          </v-col>
                        </v-row>

                      </v-card-actions>
                    </v-list>

                  </v-expand-transition>
                </v-card>
              </v-col>

            </v-row>
          </v-card-text>

        </v-card>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import i18n from "../i18n";

export default {
  name: "Profile",
  data: () => ({
    show_movie: [],
    loading: false,
    item: {
      info: {
        first_name:"",
        last_name:"",
        email:"",
        phone: "",
        country:"",
        birthday:"",
        gender: null,
        submitted_at: ''
      }
    }
  }),
  mounted() {
    this.loading = true

    let config = {
      method: 'get',
      url: this.$store.state.base_url+'/auth/user/full/',
      headers: {
        'Authorization': "token " + localStorage.getItem('token')
      }
    };
    let context = this
    axios(config)
        .then(function (response) {
          context.item.info = response.data.info
          context.item.movies = response.data.movies
          console.log(context.item.movies)
          context.replace_with_name()
          context.show_movie = new Array(context.item.movies.length)
          for (let i = 0; i < context.item.movies.length; ++i) {
            context.show_movie[i] = false;
          }
          context.loading = false
        })

  },
  methods: {

    change_open(index) {
      console.log(this.show_movie)
      this.$set(this.show_movie, index, !this.show_movie[index])
    },

    replace_with_name() {
      this.genders.forEach((element) => {
        if (element.value === this.item.info.gender) {
          this.item.info.gender = element.name
        }
      })

    },
    get_category(value) {
      let temp
      this.parts.forEach((element) => {
        if (element.value === value) {
          temp = element
        }
      })
      return temp
    },
    open_link(link) {
      window.open(link, '_blank');
    }
  },
  computed:{
    parts: function () {
      return  i18n.t("stepper.static.parts")
    },
    crew_type: function () {
      return i18n.t("stepper.static.crew_type");
    },
    crew_type_prime: function () {
      return i18n.t("stepper.static.crew_type_prime");
    },
    genders: function () {
      return i18n.t("stepper.static.genders");
    },
  }
}
</script>

<style scoped>

</style>
